import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../Redux/Slice/authSlice";
import brandReducer from "../Redux/Slice/brandSlice"; 
import reviewsReducer from '../Redux/Slice/reviewsSlice';
import productsReducer from '../Redux/Slice/productSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    brands: brandReducer, 
    reviews: reviewsReducer,
    products: productsReducer,
  },
});

export default store;
